import React from 'react'
import { Modal } from './Modal'
import { ThankyouForm } from '../Form/ThankYouForm'

const ThankyouSignUpModal = () => (
  <Modal>
    <ThankyouForm />
  </Modal>
)

export { ThankyouSignUpModal }
